import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  Link,
  Switch,
  Text,
} from "@chakra-ui/react";
import { Modal, Table, DatePicker, Select, AutoComplete } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { AdminAddEvent } from "../../Interface/AdminInterfaces";
// Claude: SubscriptionPlan removed from Events — now managed in /admin/subscriptions 19-02-2026
import { AdminAPI } from "../../Apis/adminAPI";
import Loader from "../../Components/Loader/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import { errorHandler } from "../../Utils/handler";
import { filterCountries } from "../../Utils/countries"; // Claude: country AutoComplete 27-02-2026
//import { validateEmail } from "../../Utils/Validator"; //Vishy 2025-02-18 build warning not used, so removed
import dayjs from "dayjs";
// Claude: unified upload templates with optional event fields 28-02-2026
import SellerCsv from "../../Assets/sellers_upload_template.csv";
import BuyerCsv from "../../Assets/buyers_upload_template.csv";

type Props = {};

interface Stats {
  status: string;
  count: Number | undefined;
}

// Claude: only eventName + eventCountry + eventIndustryTags are mandatory 04-03-2026
const mandatoryFields = [
  "eventName",
  "eventCountry",
];

const Events = (props: Props) => {
  const PAGESIZE = 10;

  const [loading, setLoading] = useState(false);
  const [countryOptions, setCountryOptions] = useState<{ value: string }[]>([]); // Claude: country AutoComplete 27-02-2026
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [total, setTotal] = useState(0);
  const [organiserId, setOrganiserId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const showModal = () => setIsModalVisible(true);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  //Delete
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const showDeleteModal = () => setIsDeleteModalOpen(true);

  const handleDeleteModalOk = () => setIsDeleteModalOpen(false);

  //Stats
  const [isStatsModalOpen, setIsStatsModalOpen] = useState(false);

  const showStatsModal = () => setIsStatsModalOpen(true);

  const handleStatsModalOk = () => setIsStatsModalOpen(false);

  const [meetingStats, setMeetingStats] = useState<Stats[]>([]);

  const [deleteid, setDeleteId] = useState("");

  const [formData, setFormData] = useState<AdminAddEvent>({
    organizerId: "",
    eventName: "",
    eventVenue: "",
    startDate: "",
    endDate: "",
    eventCity: "",
    eventState: "",
    eventCountry: "",
    eventUrl: "",
    eventIndustryTags: [],
  });

  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");
  // Claude: multi-select for bulk delete — array of selected event IDs 06-03-2026
  const [selectedEventIds, setSelectedEventIds] = useState<string[]>([]);
  // Claude: event name search state 06-03-2026
  const [searchName, setSearchName] = useState("");
  // Claude: server-side sort + page size 13-03-2026
  const [sortParam, setSortParam] = useState("startDate");
  const [pageSize, setPageSize] = useState(10);

  // Claude: A1 — single combined upload modal (role toggled inside) 26-02-2026
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadEventId, setUploadEventId] = useState("");
  const [uploadRole, setUploadRole] = useState<"Seller" | "Buyer">("Seller");
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [uploadDone, setUploadDone] = useState(false); // Claude: show report link after upload 07-03-2026
  const uploadFileInputRef = useRef<HTMLInputElement>(null);

  const openUploadModal = (eventId: string) => {
    setUploadEventId(eventId);
    setUploadRole("Seller");
    setUploadFile(null);
    setUploadDone(false);
    if (uploadFileInputRef.current) uploadFileInputRef.current.value = "";
    setIsUploadModalOpen(true);
  };

  // Claude: fire-and-forget — returns 202 immediately, processing in background 18-05-2026
  const handleUpload = async () => {
    if (!uploadFile) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", uploadFile);
      const res = await AdminAPI.bulkUploadUsers(fd, { role: uploadRole, eventId: uploadEventId });
      if (res) setUploadDone(true);
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  const [eventOrganisers, setEventOrganisers] = useState<any[]>([]);
  // Claude: taxonomy root nodes for industry tag picker 27-02-2026
  const [industryNodes, setTaxonomyNodes] = useState<any[]>([]);

  const [data, setData] = useState<AdminAddEvent[]>([]);

  const [singleData, setSingleData] = useState<any>({});

  const handleDelete = async (key: any) => {
    setLoading(true);
    try {
      const res = await AdminAPI.deleteEvent(key);
      if (res) success("Event deleted successfully", "");
      setSelectedEventIds([]);
      getEventData();
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  // Claude: bulk delete selected events 06-03-2026
  const handleBulkDelete = async () => {
    setLoading(true);
    try {
      await Promise.all(selectedEventIds.map((id) => AdminAPI.deleteEvent(id)));
      success(`${selectedEventIds.length} event(s) deleted successfully`, "");
      setSelectedEventIds([]);
      getEventData();
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  const meetingColumns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
    },
  ];

  // Claude: server-side sorters on DB fields; client-side for computed/lookup fields; reordered columns 13-03-2026
  const columns = [
    {
      title: "Event Name",
      dataIndex: "eventName",
      key: "eventName",
      sorter: true,
    },
    {
      title: "Country",
      dataIndex: "eventCountry",
      key: "eventCountry",
      sorter: true,
    },
    {
      title: "City",
      dataIndex: "eventCity",
      key: "eventCity",
      sorter: true,
    },
    {
      title: "Venue",
      dataIndex: "eventVenue",
      key: "eventVenue",
      sorter: true,
    },
    {
      title: "Industry",
      dataIndex: "eventIndustryTags",
      key: "eventIndustryTags",
      width: 180,
      // Claude: resolve taxonomy IDs to names for display 27-02-2026; word-wrap fix 06-03-2026
      render: (eventIndustryTags: any) => (
        <Flex flexWrap={"wrap"} gap={1}>
          {(eventIndustryTags || []).map((id: any) => {
            const node = industryNodes.find((n: any) => String(n._id) === String(id));
            return <Badge key={id} whiteSpace="normal" wordBreak="break-word">{node?.name ?? id}</Badge>;
          })}
        </Flex>
      ),
    },
    {
      title: "# of Sellers",
      dataIndex: "sellerCount",
      key: "sellerCount",
      sorter: (a: any, b: any) => (a.sellerCount || 0) - (b.sellerCount || 0),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      sorter: true,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      sorter: true,
    },
    {
      title: "Organizer",
      dataIndex: "organizerId",
      key: "organizerId",
      sorter: (a: any, b: any) => {
        const la = eventOrganisers.find((o: any) => o.value === a.organizerId)?.label || "";
        const lb = eventOrganisers.find((o: any) => o.value === b.organizerId)?.label || "";
        return la.localeCompare(lb);
      },
      render: (organizerId: any) => (
        <>
          {eventOrganisers.find((organiser: any) => organiser.value === organizerId)?.label}
        </>
      ),
    },
    {
      // Claude: A1 — Actions reordered Edit | Stats | Upload; Delete moved above grid 26-02-2026
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_: any, object: any) => (
        <>
          <Flex gap={1} flexWrap="wrap">
            <Button
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              h={"auto"}
              bg={"#0E122F"}
              color={"white"}
              px={3}
              py={1}
              fontSize={"xs"}
              _hover={{ bg: "#2E7D32" }}
              onClick={() => {
                setFormData({
                  organizerId: object.organizerId,
                  eventName: object.eventName,
                  eventVenue: object.eventVenue,
                  startDate: object.startDate,
                  endDate: object.endDate,
                  eventCity: object.eventCity,
                  eventState: object.eventState,
                  eventCountry: object.eventCountry,
                  eventUrl: object.eventUrl,
                  eventIndustryTags: object.eventIndustryTags,
                });
                setEdit(true);
                setEditId(object._id);
                showModal();
              }}
            >
              Edit
            </Button>
            <Button
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              h={"auto"}
              bg={"#0E122F"}
              color={"white"}
              px={3}
              py={1}
              fontSize={"xs"}
              _hover={{ bg: "#2E7D32" }}
              onClick={async () => {
                let singleEvent = await getEventDataByEventId(object._id);
                let data = [];
                let open = { status: "Open", count: singleEvent.openMeetings },
                  confirmed = { status: "Confirmed", count: singleEvent.confirmedMeetings },
                  closed = { status: "Closed", count: singleEvent.closedMeetings },
                  incomplete = { status: "Incomplete", count: singleEvent.incompleteMeetings },
                  canEx = { status: "Cancelled/Expired", count: singleEvent.canExMeetings },
                  total = { status: "Total", count: singleEvent.totalMeetings };
                data.push(open, confirmed, closed, incomplete, canEx, total);
                setMeetingStats(data);
                showStatsModal();
              }}
            >
              Stats
            </Button>
            <Button
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              h={"auto"}
              bg={"#0E122F"}
              color={"white"}
              px={3}
              py={1}
              fontSize={"xs"}
              _hover={{ bg: "#2E7D32" }}
              onClick={() => openUploadModal(object._id)}
            >
              Upload
            </Button>
          </Flex>
        </>
      ),
    },
  ];

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const clearData = () => {
    setFormData({
      organizerId: "",
      eventName: "",
      eventVenue: "",
      startDate: "",
      endDate: "",
      eventCity: "",
      eventState: "",
      eventCountry: "",
      eventUrl: "",
      eventIndustryTags: [],
    });
  };

  const { error, success } = useToastWrapper();

  const validate = () => {
    console.log(
      mandatoryFields.map((field) => formData[field as keyof AdminAddEvent])
    );
    if (
      mandatoryFields.some((field) => !formData[field as keyof AdminAddEvent])
    ) {
      error("Please fill all the mandatory fields", "");
      return false;
    }
    if (formData.eventIndustryTags.length === 0) {
      error("Please fill all the mandatory fields", "");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);

    // Claude: strip empty organizerId — @IsOptional() skips null/undefined but not "" 07-03-2026
    const payload = { ...formData };
    if (!payload.organizerId) delete payload.organizerId;

    if (edit) {
      try {
        const response = await AdminAPI.putEvent(editId, payload);
        success("Event Edited Successfully", "");
        handleOk();
        clearData();
        getEventData();
      } catch (err) {
        error(errorHandler(err));
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const response = await AdminAPI.postEvent(payload);
        success("Event Added Successfully", "");
        handleOk();
        clearData();
        getEventData();
      } catch (err) {
        error(errorHandler(err));
      } finally {
        setLoading(false);
      }
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      // Claude: fetch taxonomy nodes alongside organisers 27-02-2026
      const [data1, taxRes] = await Promise.all([
        AdminAPI.getOrganizer(),
        AdminAPI.getIndustryTree(),
      ]);
      if (data1 && data1.data?.data?.length > 0) {
        setEventOrganisers(
          data1.data.data.map((organiser: any) => ({
            label: organiser.organizerCompanyName,
            value: organiser._id,
          }))
        );
      }
      const flat: any[] = Array.isArray(taxRes) ? taxRes : (taxRes?.data ?? []);
      setTaxonomyNodes(flat.filter((n: any) => !n.parentId));
      // if (data2) {
      //   setData(data2.data.data);
      //   setTotal(data2.data.totalCount);
      // }
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  const getEventData = async () => {
    setLoading(true);
    try {
      const params: any = { organizerId: organiserId, limit: pageSize, page: currentPage, sort: sortParam };
      if (searchName.trim()) params.search = searchName.trim();
      const data = await AdminAPI.getEvent(params);
      console.log(data);

      setData(data.data.data);
      setTotal(data.data.totalCount);
      if (data) {
      }
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  const getEventDataByEventId = async (eventId: string) => {
    setLoading(true);
    try {
      const data = await AdminAPI.getEventById(eventId);
      console.log(data);
      // here
      // setSingleData(data.data.data);
      return data.data.data;
      if (data) {
      }
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getEventData();
  }, [organiserId, currentPage, sortParam, pageSize]);
  return (
    <div className="p-4">
      {loading ? <Loader /> : null}
      {/* Claude: Plan modal removed — subscription plans now at /admin/subscriptions 19-02-2026 */}
      {/* Delete Prompt */}
      <Modal
        title="Alert"
        footer={null}
        onCancel={handleDeleteModalOk}
        open={isDeleteModalOpen}
      >
        <Text my={5} mt={8}>
          Deleting {selectedEventIds.length === 1 ? "this event" : `these ${selectedEventIds.length} events`} will permanently remove all seller and buyer
          data linked to {selectedEventIds.length === 1 ? "it" : "them"}. Are you sure ?
        </Text>
        <Flex justifyContent="flex-end" gap={3}>
          <Button
            h="auto" px={4} py={2} variant="outline" borderColor="#0E122F" color="#0E122F"
            _hover={{ bg: "gray.100" }}
            onClick={handleDeleteModalOk}
          >
            Cancel
          </Button>
          <Button
            h="auto" px={4} py={2} bg="#C62828" color="white"
            _hover={{ bg: "red.800" }}
            onClick={() => {
              handleBulkDelete();
              handleDeleteModalOk();
            }}
          >
            Yes, Delete
          </Button>
        </Flex>
      </Modal>

      <Modal
        title="Meeting Stats"
        footer={null}
        onCancel={handleStatsModalOk}
        open={isStatsModalOpen}
      >
        <Table
          dataSource={meetingStats}
          columns={meetingColumns}
          bordered
          pagination={false}
        />
      </Modal>

      {/* Claude: constrain modal height + scroll body — matches Add Seller modal 27-02-2026 */}
      <Modal
        footer={null}
        title={edit ? "Edit Event" : "Add Event"}
        width={"80%"}
        open={isModalVisible}
        onCancel={handleOk}
        onOk={handleOk}
        centered
        bodyStyle={{ maxHeight: "calc(90vh - 110px)", overflowY: "auto" }}
      >
        <Box padding={2}>
          {/* Claude: Event Name first; only Name+Country+IndustryTags mandatory; others optional 04-03-2026 */}
          <Grid gap={4} templateColumns="repeat(3, 1fr)">
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event Name <span style={{ color: "red" }}>*</span>
                </Text>
                <Input
                  height="40px"
                  placeholder="Enter Event Name"
                  name="eventName"
                  value={formData.eventName}
                  onChange={handleChange}
                />
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event Organizer
                </Text>
                {/* Claude: type-search enabled for organizer select 06-03-2026 */}
                <Select
                  style={{ height: "40px" }}
                  value={formData.organizerId || undefined}
                  placeholder="Type to search organizer..."
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label as string ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => setFormData({ ...formData, organizerId: value ?? "" })}
                  options={eventOrganisers}
                />
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Date
                </Text>
                <div>
                  <DatePicker.RangePicker
                    className="h-[40px] w-full"
                    value={
                      formData.startDate && formData.endDate
                        ? [dayjs(formData.startDate), dayjs(formData.endDate)]
                        : null
                    }
                    onChange={(date, dateString) => {
                      setFormData({
                        ...formData,
                        startDate: dateString[0],
                        endDate: dateString[1],
                      });
                    }}
                  />
                </div>
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event Venue
                </Text>
                <Input
                  height="40px"
                  placeholder="Enter Event Venue"
                  name="eventVenue"
                  value={formData.eventVenue}
                  onChange={handleChange}
                />
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event City
                </Text>
                <Input
                  height="40px"
                  placeholder="Enter Event City"
                  name="eventCity"
                  value={formData.eventCity}
                  onChange={handleChange}
                />
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event State
                </Text>
                <Input
                  height="40px"
                  placeholder="Enter Event State"
                  name="eventState"
                  value={formData.eventState}
                  onChange={handleChange}
                />
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event Country <span style={{ color: "red" }}>*</span>
                </Text>
                {/* Claude: country AutoComplete 27-02-2026 */}
                <AutoComplete
                  style={{ width: "100%", height: "40px" }}
                  placeholder="Enter Event Country"
                  value={formData.eventCountry}
                  options={countryOptions}
                  onSearch={(q) => setCountryOptions(filterCountries(q))}
                  onChange={(val) => setFormData(prev => ({ ...prev, eventCountry: val ?? "" }))}
                />
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event URL
                </Text>
                <Input
                  height="40px"
                  placeholder="Enter Event URL"
                  name="eventUrl"
                  value={formData.eventUrl}
                  onChange={handleChange}
                />
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Text fontSize={"sm"} fontWeight={"500"}>
                  Event Industry Tags <span style={{ color: "red" }}>*</span>
                </Text>
                {/* Claude: taxonomy-driven type-and-suggest multi-select 27-02-2026 */}
                <Select
                  mode="multiple"
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label as string ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  style={{ height: "40px" }}
                  placeholder="Type to search industries..."
                  onChange={(value) => {
                    setFormData({ ...formData, eventIndustryTags: value });
                  }}
                  value={formData.eventIndustryTags}
                  options={industryNodes.map((n: any) => ({ label: n.name, value: n._id }))}
                />
              </Box>
            </GridItem>
          </Grid>

          <Box mt={10}>
            <Flex justifyContent={"end"}>
              <Button
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                h={"40px"}
                background={"primary.main"}
                color={"white"}
                px={3}
                gap={2}
                _hover={{ background: "#2E7D32" }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Flex>
          </Box>
        </Box>
      </Modal>
      {/* Claude: aligned header/toolbar styling with Sellers page 27-02-2026 */}
      <Box mt={1} mb={1}>
        <Text fontSize="md" fontWeight={600} mb={1}>Events</Text>
        <Flex gap={2} alignItems="flex-end" flexWrap="wrap">
          <Input
            placeholder="Search by name"
            type="text"
            border={"1px solid"}
            outline={"none"}
            _focus={{ outline: "none", border: "1px solid" }}
            h={"28px"}
            w={"160px"}
            px={2}
            fontSize="xs"
            borderColor={"gray.300"}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { setCurrentPage(1); getEventData(); } }}
          />
          <Box display="flex" flexDirection="column" gap={1}>
            <Text fontSize="xs" color="gray.500">Organizer</Text>
            <Select
              style={{ height: "28px", width: "190px" }}
              placeholder="All organizers"
              onChange={(value) => setOrganiserId(value)}
              options={[{ label: "All", value: "" }, ...eventOrganisers]}
              value={organiserId}
            />
          </Box>
          <Button
            h={"28px"} px={3} fontSize="xs"
            bg={"#0E122F"} color={"white"}
            _hover={{ bg: "#2E7D32" }}
            onClick={() => { setCurrentPage(1); getEventData(); }}
          >
            Search
          </Button>
          <Button
            display={"flex"}
            onClick={() => {
              setEdit(false);
              clearData();
              setEditId("");
              showModal();
            }}
            justifyContent={"center"}
            alignItems={"center"}
            h={"28px"}
            bg={"#0E122F"}
            color={"white"}
            px={3}
            fontSize="xs"
            gap={2}
            _hover={{ bg: "#2E7D32" }}
          >
            <AiOutlinePlus /> Event
          </Button>
        </Flex>
      </Box>

      {/* Claude: delete button always visible, consistent with Sellers; table font/size matched 27-02-2026 */}
      <Flex justifyContent="start" alignItems="center" gap={2} mb={1}>
        <Button
          size="xs"
          fontSize="xs"
          background={"secondary.light"}
          color={"secondary.main"}
          px={3}
          _hover={{ background: "#C62828", color: "white" }}
          onClick={() => {
            if (selectedEventIds.length > 0) {
              showDeleteModal();
            } else {
              error("Please select an event to delete !");
            }
          }}
        >
          Delete{selectedEventIds.length > 0 ? ` (${selectedEventIds.length})` : ""}
        </Button>
        <Text fontSize="xs" color="gray.500">
          {total === 0 ? "No events" : `${total} events`}
        </Text>
      </Flex>

      <Box mt={1} sx={{ "& .ant-table": { fontSize: "12px" }, "& .ant-table-cell": { fontSize: "12px" } }}>
        <Table
          size="small"
          style={{ width: "100%" }}
          dataSource={data}
          columns={columns}
          bordered
          pagination={false}
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectedEventIds,
            onChange: (keys) => setSelectedEventIds(keys as string[]),
          }}
          rowKey="_id"
          onChange={(_pg, _filters, sorter: any) => { // Claude: server-side sort on column header click 13-03-2026
            if (sorter.field && sorter.order) {
              setSortParam(sorter.order === "descend" ? `-${sorter.field}` : sorter.field);
            } else {
              setSortParam("startDate");
            }
            setCurrentPage(1);
          }}
        />
        <Flex justifyContent={"end"} alignItems="center" gap={2} mt={1}>
          {/* Claude: page size dropdown 13-03-2026 */}
          <Select
            size="small"
            value={pageSize}
            onChange={(val) => { setPageSize(val); setCurrentPage(1); }}
            options={[
              { label: "10 / page", value: 10 },
              { label: "25 / page", value: 25 },
              { label: "50 / page", value: 50 },
              { label: "100 / page", value: 100 },
              { label: "All", value: 9999 },
            ]}
            style={{ width: 110 }}
          />
          <Pagination
            current={currentPage}
            total={total}
            onChange={(number) => setCurrentPage(number)}
            pageSize={pageSize}
          />
        </Flex>
      </Box>

      {/* Claude: A1 — Combined upload modal (Exhibitors / Visitors toggled inside) 26-02-2026 */}
      <Modal
        footer={null}
        title="Upload Participants (CSV)"
        width={"40%"}
        open={isUploadModalOpen}
        onCancel={() => setIsUploadModalOpen(false)}
      >
        <Box p={2}>
          {/* Claude: fire-and-forget success state — file received, processing in background 18-05-2026 */}
          {uploadDone ? (
            <Box textAlign="center" py={4}>
              <Text fontSize="md" fontWeight="700" mb={2}>Upload submitted!</Text>
              <Text fontSize="sm" color="gray.600" mb={4}>
                <b>{uploadFile?.name}</b> has been received and is being processed in the background.
              </Text>
              <Text fontSize="xs" color="gray.500" mb={4}>
                Check Upload Reports in a few minutes to see the results.
              </Text>
              <Link href="/admin/upload-reports" color="blue.500" fontSize="sm" fontWeight={500} _hover={{ color: "blue.700", textDecoration: "underline" }}>
                View Upload Reports →
              </Link>
              <Flex justifyContent="center" mt={5}>
                <Button size="sm" fontSize="xs" px={5} bg="gray.100" color="gray.600" _hover={{ bg: "gray.200" }} onClick={() => setIsUploadModalOpen(false)}>
                  Close
                </Button>
              </Flex>
            </Box>
          ) : (
          <>
          {/* Role toggle */}
          <Flex gap={2} mb={4}>
            <Button
              flex={1}
              bg={uploadRole === "Seller" ? "#0E122F" : "gray.100"}
              color={uploadRole === "Seller" ? "white" : "black"}
              _hover={{ background: "#2E7D32", color: "white" }}
              onClick={() => {
                setUploadRole("Seller");
                setUploadFile(null);
                if (uploadFileInputRef.current) uploadFileInputRef.current.value = "";
              }}
            >
              Exhibitors/Sellers
            </Button>
            <Button
              flex={1}
              bg={uploadRole === "Buyer" ? "#0E122F" : "gray.100"}
              color={uploadRole === "Buyer" ? "white" : "black"}
              _hover={{ background: "#2E7D32", color: "white" }}
              onClick={() => {
                setUploadRole("Buyer");
                setUploadFile(null);
                if (uploadFileInputRef.current) uploadFileInputRef.current.value = "";
              }}
            >
              Visitors/Buyers
            </Button>
          </Flex>

          {/* Sample CSV download */}
          <Flex gap={2} alignItems={"center"} mb={3}>
            <Text fontSize="sm">Download Sample CSV</Text>
            <a href={uploadRole === "Seller" ? SellerCsv : BuyerCsv} download>
              <Button bg={"primary.main"} color={"white"} px={3} py={1} h={"auto"} fontSize="sm">
                Download
              </Button>
            </a>
          </Flex>

          <Text fontSize={"xs"} color={"gray.500"} mb={3}>
            {uploadRole === "Seller"
              ? "Booth number and event name columns are optional — leave blank if not applicable."
              : "Event name column is optional — leave blank if not applicable."}
          </Text>

          {/* Claude: existing-user merge behaviour note 08-03-2026 */}
          <Text fontSize={"xs"} color={"blue.600"} mb={3}>
            <b>For existing accounts:</b> empty fields will be filled from the upload; fields that already have a value will not be overwritten. Use individual edits to change existing values.
          </Text>

          <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
            <Text fontSize={"sm"} fontWeight={"500"}>CSV File</Text>
            <Input
              type="file"
              height="40px"
              ref={uploadFileInputRef}
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) setUploadFile(e.target.files[0]);
              }}
            />
          </Box>
          {uploadFile && (
            <Flex justifyContent={"end"} mt={6}>
              <Button bg={"primary.main"} color={"white"} px={4} h={"40px"} _hover={{ background: "#2E7D32" }} onClick={handleUpload}>
                Submit
              </Button>
            </Flex>
          )}
          </>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default Events;
